/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { i18nData } from 'helpers/i18n';
import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticeHandsHips3 from '../../images/characters/apprenticeHandsHips3.png';
import apprenticeArmsFolded2 from '../../images/characters/apprenticeArmsFolded2.png';
import apprenticesBackToBack from '../../images/characters/apprenticesBackToBack.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';
import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import saraTwistHandsOutHeyhey from '../../images/characters/sara_twist_hands_out_heyhey.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';
import ianPointingLeft from '../../images/characters/ian_pointing_left.png';
import ianPointingDown from '../../images/characters/ian_pointing_down.png';
import saraSmile from '../../images/characters/sara_smile.png';
import saraHumph from '../../images/characters/sara_humph.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';
import ianSide from '../../images/characters/ian_side.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1a_en from './level1a_teamBrainstorm.md';
import markdownFileLevel1a_fr_CA from './level1a_teamBrainstorm.fr_CA.md';
import markdownFileLevel1b_en from './level1b_writePoemRap.md';
import markdownFileLevel1b_fr_CA from './level1b_writePoemRap.fr_CA.md';
import markdownFileLevel2_en from './level2_groupDrawing.md';
import markdownFileLevel2_fr_CA from './level2_groupDrawing.fr_CA.md';
import markdownFileLevel3_en from './level3_poster.md';
import markdownFileLevel3_fr_CA from './level3_poster.fr_CA.md';
import markdownFileLevel4_en from './level4_skit.md';
import markdownFileLevel4_fr_CA from './level4_skit.fr_CA.md';

const markdownFileLevel1a = i18nData({
  en: new MarkdownScript(markdownFileLevel1a_en),
  fr_CA: new MarkdownScript(markdownFileLevel1a_fr_CA)
});
const markdownFileLevel1b = i18nData({
  en: new MarkdownScript(markdownFileLevel1b_en),
  fr_CA: new MarkdownScript(markdownFileLevel1b_fr_CA)
});
const markdownFileLevel2 = i18nData({
  en: new MarkdownScript(markdownFileLevel2_en),
  fr_CA: new MarkdownScript(markdownFileLevel2_fr_CA)
});
const markdownFileLevel3 = i18nData({
  en: new MarkdownScript(markdownFileLevel3_en),
  fr_CA: new MarkdownScript(markdownFileLevel3_fr_CA)
});
const markdownFileLevel4 = i18nData({
  en: new MarkdownScript(markdownFileLevel4_en),
  fr_CA: new MarkdownScript(markdownFileLevel4_fr_CA)
});

const levels = {
  '1a': { md: markdownFileLevel1a },
  '1b': { md: markdownFileLevel1b },
  '2': { md: markdownFileLevel2 },
  '3': { md: markdownFileLevel3 },
  '4': { md: markdownFileLevel4 }
};

export function preloadClassActivity () {
  preloader([
    esHandsOutWehey,
    ianHeadshotSmile,
    apprenticeHandsHips3,
    apprenticeArmsFolded2,
    apprenticesBackToBack,
    saraSurprised,
    saraTwistHandsOutHeyhey,
    ianPointingUp,
    ianPointingLeft,
    ianPointingDown,
    saraSmile,
    saraHumph,
    ianSaraLeanQuestioning,
    ianSide
  ]);
}

function sizzle (level, regionData, md) {
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'left',
      characterImage: apprenticeHandsHips3,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function instructions (level, regionData, md) {
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'right',
      characterImage: apprenticeArmsFolded2,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}

function scoring (level, regionData, md) {
  return (
    balloonSlide({
      id: 'scoring',
      characterSide: 'right',
      characterImage: apprenticesBackToBack,
      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
    })
  );
}

function level1a (regionData, i18n) { // Group drawing
  const level = '1a';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level1b (regionData, i18n) { // Group drawing
  const level = '1b';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

      {/* Scoring */}
      {scoring(level, regionData, md)}


    </Section>
  );
}

function level2 (regionData, i18n) { // Popcorn Joys
  const level = '2';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

      {/* Scoring */}
      {scoring(level, regionData, md)}

    </Section>
  );
}

function level3 (regionData, i18n) { // Waste math
  const level = '3';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function level4 (regionData, i18n) { // Eat me first box
  const level = '4';
  const md = i18n(levels[level].md);
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData, md)}

      {/* Instructions */}
      {instructions(level, regionData, md)}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData, i18n }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1a':
    return level1a(regionData, i18n);
  case '1b':
    return level1b(regionData, i18n);
  case '2':
    return level2(regionData, i18n);
  case '3':
    return level3(regionData, i18n);
  case '4':
    return level4(regionData, i18n);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/30_classActivity/classActivitySection.jsx